import Wechat from "@/assets/icons/profile/wechat";
import { IconWrapper } from "@/pages/profile/components/atom";

export function BindWechatIcon() {
  return (
    <IconWrapper>
      <Wechat />
    </IconWrapper>
  );
}
